import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const RadioUnchecked = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
);
export default RadioUnchecked;
